import type { NamedSet } from 'zustand/middleware';

import type { ZustandStore } from '../store.type';

type ErrorState = {
	error: {
		heading: string;
		message: string;
		/*
		 * sometimes for example when using team switcher and switching roles
		 * we want to prevent showing the error page
		 * if the new role does not have access to current page
		 * due to new selectedTeamId
		 */
		preventShowErrorPage: boolean;
	};
};

type ErrorActions = {
	setErrorMessage: ({ heading, message }: Partial<ErrorState['error']>) => void;
	setPreventShowErrorPage: (preventShowErrorPage: boolean) => void;
};

export type ErrorSlice = ErrorState & ErrorActions;

const errorInitialState: ErrorState = {
	error: {
		heading: 'Something is not right',
		message: 'The action you’re trying to perform cannot be completed. In some cases simply trying again helps.',
		preventShowErrorPage: false,
	},
};

export function errorSlice(set: NamedSet<ZustandStore>): ErrorSlice {
	return {
		...errorInitialState,
		setErrorMessage({ heading = '', message = '' }: Partial<ErrorState['error']>): void {
			set(
				(state: ErrorState) => {
					state.error.heading = heading;
					state.error.message = message;
					return state;
				},
				false,
				'[SetErrorMessage]',
			);
		},
		setPreventShowErrorPage(preventShowErrorPage: boolean): void {
			set(
				(state: ErrorState) => {
					state.error.preventShowErrorPage = preventShowErrorPage;
					return state;
				},
				false,
				'[SetPreventShowErrorPage]',
			);
		},
	};
}
